<template>
  <div class="sidebar" :class="{ opened }">
    <nav class="nav-wrapper">
      <ul class="nav">
        <li class="nav-item">
          <NuxtLink to="/account/" class="link">
            <span class="icon" v-html="nav[0].icon"></span>{{ nav[0].label }}
          </NuxtLink>
        </li>
        <li class="nav-item">
          <NuxtLink to="/account/plan/" class="link">
            <span class="icon" v-html="nav[1].icon"></span>{{ nav[1].label }}
          </NuxtLink>
        </li>
        <li class="nav-item">
          <NuxtLink to="/account/billing/" class="link">
            <span class="icon" v-html="nav[2].icon"></span>{{ nav[2].label }}
          </NuxtLink>
        </li>
        <li class="nav-item">
          <NuxtLink to="/account/team/" class="link">
            <span class="icon" v-html="nav[3].icon"></span>{{ nav[3].label }}
          </NuxtLink>
        </li>
        <li class="nav-item">
          <NuxtLink to="/account/support/" class="link">
            <span class="icon" v-html="nav[4].icon"></span>{{ nav[4].label }}
          </NuxtLink>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup>
import ChevronRightSvg from '~/layers/base/assets/icons/chevron-right.svg?raw'
const textsStore = useTextsStore()

const nav = computed(() => {
  return textsStore.account.nav.items
})

const opened = ref(false)

const toggleNav = () => {
  opened.value = !opened.value
}

const toggleNavText = computed(() => {
  return opened.value
    ? textsStore.account.nav.hide_nav
    : textsStore.account.nav.show_nav
})
</script>

<style lang="scss" scoped>
.sidebar {
  @media (min-width: 1024px) {
    border-radius: 10px;
    border: 1px solid var(--bubble-10, rgba(0, 0, 0, 0.1));
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    background: var(--Block-bg, #fff);
    width: 230px;
    position: sticky;
    top: 70px;
    padding: 15px;
  }
  @media (max-width: 1023px) {
    width: 100%;
    position: static;
  }
}

.nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 1023px) {
    overflow: hidden;
    flex-direction: row;
    gap: 15px;
  }
}

.link {
  @media (min-width: 1024px) {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 15px;
    border-radius: 10px;
    transition: background-color 0.3s;
    font-size: 1.8rem;
    letter-spacing: 0.18px;
    min-height: 42px;
    line-height: 100%;
  }
  @media (max-width: 1023px) {
    opacity: 0.5;
    font-size: 1.4rem;
    padding: 5px 0;
    display: block;
  }

  .icon {
    @media (max-width: 1023px) {
      display: none;
    }
  }

  :deep(svg) {
    display: block;
    opacity: 0.5;

    path {
      stroke: var(--Text, #000);
    }
  }

  &:hover,
  &.router-link-exact-active {
    @media (max-width: 1023px) {
      opacity: 1;
      border-bottom: 1px solid var(--Text, #000);
    }
    @media (min-width: 1024px) {
      background: var(--bubble-10, rgba(0, 0, 0, 0.1));
    }
  }
}
</style>
